import { action } from '@storybook/addon-actions';

import type {
  BuddyResponseProps,
  BuddySuggestedArticlesProps,
  AIArticleSummaryProps,
  QuickFilter
} from '@pega/cosmos-react-work';
import type { MenuProps, OmitStrict } from '@pega/cosmos-react-core';

const categoryList = [
  {
    id: 'Category-1',
    name: 'Banking and Retail'
  },
  {
    id: 'Category-2',
    name: 'Retail'
  },
  {
    id: 'Category-3',
    name: 'Finance'
  },
  {
    id: 'Category-4',
    name: 'Insurance'
  }
];

export const suggestedMock = {
  count: 5,
  articles: [
    {
      articleId: '1',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate',
      abstract: 'Candy cotton candy tiramisu danish halvah pie.',
      meta: {
        category: categoryList[0].name,
        publishedDate: '2023-04-06'
      },
      feedback: {
        likes: 20,
        dislikes: 80,
        liked: true,
        disliked: false
      },
      isFollowed: true,
      isLiked: true
    },
    {
      articleId: '2',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate',
      href: 'https://design.pega.com',
      abstract: 'Cotton candy toffee tiramisu danish halvah pie.',
      meta: {
        category: categoryList[1].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 50, dislikes: 50, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '1', name: 'insurance' },
        { id: '2', name: 'policy' },
        { id: '3', name: 'case2' },
        { id: '4', name: 'en' },
        { id: '5', name: 'insurance' },
        { id: '6', name: 'policy' },
        { id: '7', name: 'case' },
        { id: '8', name: 'uk' }
      ]
    }
  ],
  aiSuggestions: [
    {
      articleId: '3',
      title: 'Steps for opening a new account for existing users',
      semanticSearch: false,
      score: 97
    },
    {
      articleId: '4',
      semanticSearch: false,
      title: 'Verification requirements for a new account',
      href: 'https://design.pega.com',
      score: 91
    },
    {
      articleId: '5',
      semanticSearch: false,
      title: 'Teen money checking FAQ',
      href: 'https://design.pega.com',
      score: 86
    }
  ]
};
export const followedMock = {
  count: 7,
  articles: [
    {
      articleId: '1',
      title: 'Oat cake jujubes pudding macaroon apple pie biscuit liquorice',
      abstract:
        'Candy cotton candy tiramisu danish halvah pie. Macaroon chupa chups chupa chups tiramisu bear claw liquorice croissant. Powder tart chupa chups.',
      meta: {
        category: categoryList[1].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 47, dislikes: 15, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '17', name: 'profiles' },
        { id: '18', name: 'accounts' },
        { id: '19', name: 'banking' }
      ]
    },
    {
      articleId: '2',
      title: 'Bear claw jujubes pastry jujubes chocolate bar chupa ',
      href: 'https://design.pega.com',
      abstract:
        'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
      meta: {
        category: categoryList[0].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 15, dislikes: 85, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '20', name: 'profiles' },
        { id: '21', name: 'accounts' },
        { id: '22', name: 'banking' }
      ]
    },

    {
      articleId: '3',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate marzipan sweet',
      href: 'https://design.pega.com',
      abstract:
        'Ice cream dragée ice cream bear claw. Bonbon icing marshmallow fruitcake. Carrot cake chocolate cake pie dessert ',
      meta: {
        category: categoryList[2].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 89, dislikes: 33, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '23', name: 'profiles' },
        { id: '24', name: 'accounts' },
        { id: '25', name: 'banking' }
      ]
    },
    {
      articleId: '4',
      title: 'Tootsie roll tiramisu jujubes gingerbread macaroon jujubes',
      abstract:
        'Pudding bear claw sweet sugar plum jelly wafer. Jelly beans chocolate bar jelly-o jelly dessert. Danish toffee lollipop t',
      meta: {
        category: categoryList[3].name,
        publishedDate: '2023-04-06'
      },
      feedback: {
        likes: 95,
        dislikes: 5,
        liked: false,
        disliked: false
      },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '26', name: 'profiles' },
        { id: '27', name: 'accounts' },
        { id: '28', name: 'banking' }
      ]
    },
    {
      articleId: '5',
      title: 'Bear claw jujubes pastry jujubes chocolate bar chupa ',
      abstract:
        'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.',
      meta: {
        category: categoryList[0].name,
        publishedDate: '2023-04-06'
      },
      feedback: {
        likes: 15,
        dislikes: 85,
        liked: false,
        disliked: false
      },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '29', name: 'profiles' },
        { id: '30', name: 'accounts' },
        { id: '31', name: 'banking' }
      ]
    },
    {
      articleId: '6',
      title: 'Oat cake jujubes pudding macaroon apple pie biscuit liquorice',
      href: 'https://design.pega.com',
      abstract:
        'Candy cotton candy tiramisu danish halvah pie. Macaroon chupa chups chupa chups tiramisu bear claw liquorice croissant. Powder tart chupa chups.',
      meta: {
        category: categoryList[1].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 47, dislikes: 15, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '32', name: 'profiles' },
        { id: '33', name: 'accounts' },
        { id: '34', name: 'banking' }
      ]
    },
    {
      articleId: '7',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate marzipan sweet',
      href: 'https://design.pega.com',
      abstract:
        'Ice cream dragée ice cream bear claw. Bonbon icing marshmallow fruitcake. Carrot cake chocolate cake pie dessert ',
      meta: {
        category: categoryList[2].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 89, dislikes: 33, liked: false, disliked: false },
      isFollowed: true,
      isLiked: true
    }
  ],
  category: [
    {
      id: '01',
      primary: 'Group',
      secondary: ['Experts', 'Loans'],
      items: [
        { id: '01-1', primary: 'Personal loan', secondary: ['Experts', 'Loans'] },
        { id: '01-2', primary: 'Education loan', secondary: ['Experts', 'Loans'] },
        { id: '01-3', primary: 'Auto loan', secondary: ['Experts', 'Loans'] }
      ]
    },
    { id: '3', primary: 'Credit card', secondary: ['Intermediate', 'Banking'] },
    { id: '4', primary: 'General Q & A', secondary: ['Intermediate', 'Others'] },
    { id: '5', primary: 'Debit card', secondary: ['Intermediate', 'Banking'] },
    { id: '6', primary: 'Retail banking', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-1', primary: 'Banking and Retail', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-2', primary: 'Retail', secondary: ['Intermediate', 'Others'] },
    { id: 'Category-3', primary: 'Finance', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-4', primary: 'Insurance', secondary: ['Intermediate', 'Banking'] }
  ],
  sortBy: [
    { id: '1', primary: 'Most relevant' },
    { id: '2', primary: 'Most recent' },
    { id: '3', primary: 'Recently published' }
  ]
};

export const searchMock = {
  count: 5,
  articles: [
    {
      articleId: '8',
      title: 'Tootsie roll tiramisu jujubes gingerbread macaroon jujubes',
      href: 'https://design.pega.com',
      abstract:
        'Pudding bear claw sweet sugar plum jelly wafer. Jelly beans chocolate bar jelly-o jelly dessert. Danish toffee lollipop t',
      meta: {
        category: categoryList[3].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 95, dislikes: 5, liked: true, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '35', name: 'profiles' },
        { id: '36', name: 'accounts' },
        { id: '37', name: 'banking' }
      ]
    },
    {
      articleId: '3',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate marzipan sweet',
      href: 'https://design.pega.com',
      abstract:
        'Ice cream dragée ice cream bear claw. Bonbon icing marshmallow fruitcake. Carrot cake chocolate cake pie dessert ',
      meta: {
        category: categoryList[2].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 89, dislikes: 33, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '38', name: 'profiles' },
        { id: '39', name: 'accounts' },
        { id: '40', name: 'banking' }
      ]
    },
    {
      articleId: '6',
      title: 'Oat cake jujubes pudding macaroon apple pie biscuit liquorice',
      abstract:
        'Candy cotton candy tiramisu danish halvah pie. Macaroon chupa chups chupa chups tiramisu bear claw liquorice croissant. Powder tart chupa chups.',
      meta: {
        category: categoryList[1].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 47, dislikes: 15, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '41', name: 'profiles' },
        { id: '42', name: 'accounts' },
        { id: '43', name: 'banking' }
      ]
    },
    {
      articleId: '7',
      title: 'Cookie jelly-o lemon drops gingerbread chocolate marzipan sweet',
      abstract:
        'Ice cream dragée ice cream bear claw. Bonbon icing marshmallow fruitcake. Carrot cake chocolate cake pie dessert ',
      meta: {
        category: categoryList[2].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 89, dislikes: 33, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '44', name: 'profiles' },
        { id: '45', name: 'accounts' },
        { id: '46', name: 'banking' }
      ]
    },
    {
      articleId: '2',
      title: 'Oat cake jujubes pudding macaroon apple pie biscuit liquorice',
      abstract:
        'Candy cotton candy tiramisu danish halvah pie. Macaroon chupa chups chupa chups tiramisu bear claw liquorice croissant. Powder tart chupa chups.',
      meta: {
        category: categoryList[1].name,
        publishedDate: '2023-04-06'
      },
      feedback: { likes: 47, dislikes: 15, liked: false, disliked: false },
      isFollowed: false,
      isLiked: true,
      quickFilters: [
        { id: '47', name: 'profiles' },
        { id: '48', name: 'accounts' },
        { id: '49', name: 'banking' }
      ]
    }
  ],
  category: [
    {
      id: '1',
      primary: 'Group',
      secondary: ['Experts', 'Loans'],
      items: [
        { id: '1-1', primary: 'Personal loan', secondary: ['Experts', 'Loans'] },
        { id: '1-2', primary: 'Education loan', secondary: ['Experts', 'Loans'] },
        { id: '1-3', primary: 'Auto loan', secondary: ['Experts', 'Loans'] }
      ]
    },
    { id: '3', primary: 'Credit card', secondary: ['Intermediate', 'Banking'] },
    { id: '4', primary: 'General Q & A', secondary: ['Intermediate', 'Others'] },
    { id: '5', primary: 'Debit card', secondary: ['Intermediate', 'Banking'] },
    { id: '6', primary: 'Retail banking', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-1', primary: 'Banking and Retail', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-2', primary: 'Retail', secondary: ['Intermediate', 'Others'] },
    { id: 'Category-3', primary: 'Finance', secondary: ['Intermediate', 'Banking'] },
    { id: 'Category-4', primary: 'Insurance', secondary: ['Intermediate', 'Banking'] }
  ],
  sortBy: [
    { id: '1', primary: 'Most relevant' },
    { id: '2', primary: 'Most recent' },
    { id: '3', primary: 'Recently published' }
  ]
};

export const ArticleBuddyMockData: Pick<
  BuddyResponseProps,
  'title' | 'references' | 'disclaimer'
> & { content: string } = {
  title: 'How much is the most I’ll have to pay for a late fee?',
  content:
    "<p>Changing your monthly billing cycle can help you better manage your monthly bills and when you pay them.  U+Comm offers 3 main billing cycles with due dates falling on the 1st, 15th, or the 28th of each month.  This provides our customers with flexibility when choosing a billing cycle and corresponding due date that matches your personal finance planning.If you change an existing bill cycle, there will generally be a number of days prorated to compensate from the gap from the end of the previous bill cycle to when the new bill cycle is started.  This proration will be included in your next (new) billing cycle statement, and will cause an increase in that month’s payment due.  But rest assured, you’re not being charged ‘extra’, but paying for the days that were between the old and new billing cycle dates.</p><div>Find more details from this article <a data-article-id='5' href='#'>How to sell a product</a></div><div>Find some suggestions from this article <a data-article-id='8' href='#'>How to convince a customer</a></div><div><b>Before you change your billing cycle, be aware that:</b> </div><ul><li>Your billing cycle can't be changed if your account is in a delinquent status, or if the account will fall delinquent before the requested change date.</li><li>If you have a payment arrangement set up, the payment arrangement must be made before the billing cycle is changed.</li><li>If you have AutoPay, you may see two AutoPay drafts in one month due to the billing cycle change.</li><li>When a billing cycle change is made, prorated charges will occur.</li><li>Your billing cycle can't be changed if your account is in a delinquent status, or if the account will fall delinquent before the requested change date.</li> </ul>",
  references: [
    {
      id: '1',
      href: 'https://pega.com',
      name: 'Payment penalties for late auto payments',
      confidence: 30,
      type: 'link'
    },
    {
      id: '2',
      href: 'https://pega.com',
      name: 'Payment penalties for delay',
      confidence: 20,
      type: 'link'
    },
    {
      id: '3',
      href: 'https://pega.com',
      name: 'Payment penalties ',
      confidence: 5,
      type: 'link'
    },
    {
      id: '4',
      name: 'Payment penalties ',
      confidence: 5,
      onClick: (id: string) => {
        action('Follow')(id);
      },
      type: 'object'
    }
  ],
  disclaimer: 'Generated by AI. Answers may be incomplete or inaccurate.'
};

export const ArticleBuddyActions = {
  items: [
    {
      id: '1',
      text: 'Copy',
      onClick: () => {}
    },
    {
      id: '2',
      text: 'Share',
      onClick: () => {}
    }
  ]
};

export const BuddyListMockData: BuddySuggestedArticlesProps = {
  autoAnswered: [
    {
      id: '1',
      query: 'What is UPlus protection plan?',
      abstract:
        'This plan id for few customers who upgraded to the platinum plan, apart from regular connection.',
      onTitleClick: id => {
        action(id);
      }
    },
    {
      id: '2',
      query: 'What are the new plans?',
      abstract:
        'This plan id for few customers who upgraded to the platinum plan, apart from regular connection.',
      onTitleClick: id => {
        action(id);
      }
    }
  ],
  detected: [
    {
      id: '3',
      query: 'When is the bill due?',
      confidence: 90,
      onTitleClick: id => {
        action(id);
      }
    },
    {
      id: '4',
      query: 'Will my balance update next week?',
      confidence: 80,
      onTitleClick: id => {
        action(id);
      }
    },
    {
      id: '5',
      query: 'How do I add another person to y plan?',
      confidence: 70,
      onTitleClick: id => {
        action(id);
      }
    }
  ],
  pastQuestions: [
    'What is the new policy?',
    'Can this be exchanged?',
    'Can I change my address on the mobile app?',
    'Can I change my address on the web app?',
    'Can I change my address on the desktop app?'
  ],
  notRelevantQuestions: [
    'What is the new policy?',
    'Can this be exchanged?',
    'Can I change my address on the mobile ?'
  ]
};

export interface AdditionalParams extends QuickFilter {
  metadata?: string;
}

export const searchSemanticArticles: (OmitStrict<AIArticleSummaryProps, 'quickFilters'> & {
  quickFilters?: AdditionalParams[];
})[] = [
  {
    articleId: '3',
    title: 'Steps for opening a new account for existing users',
    abstract: 'Ice cream dragée ice cream bear claw.',
    score: 97,
    href: 'https://design.pega.com',
    semanticSearch: true,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    },
    quickFilters: [
      { id: 'banking account', name: 'account', metadata: 'en' },
      { id: 'banking savings', name: 'savings', metadata: 'en' }
    ]
  },
  {
    articleId: '4',
    title: 'Verification requirements for a new account',
    href: 'https://design.pega.com',
    semanticSearch: true,
    score: 97,
    quickFilters: [
      { id: '39', name: 'account' },
      { id: '40', name: 'banking' },
      { id: '41', name: 'cheque' },
      { id: '42', name: 'notebook' },
      { id: '43', name: 'en' },
      { id: '44', name: 'germany' },
      { id: '45', name: 'spain' },
      { id: '46', name: 'NYC' },
      { id: '47', name: 'cambridge' },
      { id: '48', name: 'bali' },
      { id: '49', name: 'Singapore' },
      { id: '50', name: 'india' }
    ],

    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '5',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '6',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '7',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '8',
    semanticSearch: true,
    title: 'Oat cake jujubes pudding macaroon apple pie biscuit',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '9',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '10',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '11',
    semanticSearch: true,
    title: 'Teen money checking FAQ',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  },
  {
    articleId: '12',
    semanticSearch: true,
    title: 'Oat cake jujubes pudding macaroon apple pie biscuit',
    href: 'https://design.pega.com',
    score: 86,
    actions: {
      items: [
        { id: '1', text: 'Share' },
        { id: '2', text: 'Copy' }
      ]
    }
  }
];

export const semanticFilterOptions: MenuProps['items'] = [
  {
    id: 'banking',
    label: 'Banking',
    items: [
      {
        id: 'banking account',
        primary: 'account'
      },
      {
        id: 'banking savings',
        primary: 'savings'
      },
      {
        id: 'banking current',
        primary: 'current'
      }
    ]
  },
  {
    id: 'customer',
    label: 'Customer',
    items: [
      {
        id: 'cutomer service',
        primary: 'service'
      },
      {
        id: 'cutomer help',
        primary: 'help'
      }
    ]
  },
  {
    id: 'investment',
    label: 'Investment',
    items: [
      {
        id: 'investment funds',
        primary: 'funds'
      },
      {
        id: 'investment refund',
        primary: 'refund'
      },
      {
        id: 'investment withdrawal',
        primary: 'withdrawal'
      }
    ]
  }
];
